import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, Form, FormGroup, Radio, Fieldset, H2, H4 } from "@bigcommerce/big-design";

const hookDescriptions = {
  23122668: "~ sync live orders to sandbox"
}

function Webhooks(props) {
  const [state, setState] = useState({
    hooks: [],
    message: "loading",
  });

  const listHooks = async () => {
    await axios.get(`/api/webhooks/list`)
      .then(({ data }) => {
        setState(prevState => { return {...prevState, hooks: data, message: "ok" } });
      })
      .catch((error) => setState(prevState => { return {...prevState, message: error.message } }));
  };

  useEffect(() => {
    listHooks();
  }, []);

  const updateHook = async (id, is_active) => {
    let url = `/api/webhooks/update/${id}/${is_active}`;
    await axios.put(url);
    listHooks();
  };

  const handleOnChange = (e) => {
    let [webhookId, is_active] = e.target.name.split(" - ");
    console.log({ webhookId, is_active });
    updateHook(webhookId, is_active);
  };
  return (
    <Box padding="medium">
      <H2>Webhooks</H2>
      <H4>{state.message}</H4>
      <Form>
        {state.hooks.map((webhook, i) => (
          <Fieldset key={i} legend={`${webhook.id} - ${webhook.scope} ${hookDescriptions[webhook.id] || ""}`}>
            <FormGroup>
              <Radio
                label="On"
                checked={webhook.is_active}
                value="true"
                name={`${webhook.id} - true`}
                onChange={handleOnChange}
              />
              <Radio
                label="Off"
                checked={!webhook.is_active}
                value="false"
                name={`${webhook.id} - false`}
                onChange={handleOnChange}
              />
            </FormGroup>
          </Fieldset>
        ))}
      </Form>
    </Box>
  );
}

export default Webhooks;
